import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("appomax_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function imgUrl(src) {
  if (!src) return "";
  return src.startsWith("http") ? src : `${BACKEND_URL}${src}`;
}

export function apiErr(e, fallback = "Ocurrió un error") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || fallback;
}

export default api;
